export default {
    track(event, data = {}) {
        if (typeof fbq === 'undefined') {
            console.warn('[FB Pixel] fbq is not defined')
            return
        }
        window.fbq('track', event, data)
        console.log(`[FB Pixel] Tracked: ${event}`, data)
    },

    trackCustom(event, data = {}) {
        if (typeof fbq === 'undefined') {
            console.warn('[FB Pixel] fbq is not defined')
            return
        }
        window.fbq('trackCustom', event, data)
        console.log(`[FB Pixel] Custom Tracked: ${event}`, data)
    },
}
